!((document, Drupal) => {
  'use strict';

  // Create dropdown menu functionality
  const dropdownMenu = (context) => {
    // Get all dropdown menus on the page
    const dropdownMenus = context.querySelectorAll('.dropdown-menu');
    const dropdownMenusLength = dropdownMenus.length;

    // If there are no dropdown menus, exit function
    if (!dropdownMenusLength) {
      return;
    }

    // Get all expand buttons in the dropdown menus
    const dropdownButtonsNodeList = context.querySelectorAll(
      '.dropdown-menu__expand-button'
    );
    const dropdownButtonsLength = dropdownButtonsNodeList.length;

    // Convert nodelist to array
    const dropdownButtons = Array.from(dropdownButtonsNodeList);

    // Get top level buttons in the dropdown menus
    const topLevelButtons = dropdownButtons.filter((button) =>
      button.parentElement.classList.contains('dropdown-menu__item')
    );

    // Get the first item of each submenu
    const secondLevelFirstItems = context.querySelectorAll(
      '.dropdown-menu__item li:first-child'
    );
    const secondLevelFirstItemsLength = secondLevelFirstItems.length;

    // Get the template for the back button
    const backButtonTemplate = document.querySelector(
      '.dropdown-menu__back-button-template'
    );

    // Create a set to store added back buttons
    const addedBackButtons = new Set();

    // Open submenu on button click
    const openSubmenu = (button) => {
      button.classList.add('dropdown-menu__expand-button--expanded');
      button.setAttribute('aria-expanded', 'true');
    };

    // Close submenu on button click
    const closeSubmenu = (button) => {
      button.classList.remove('dropdown-menu__expand-button--expanded');
      button.setAttribute('aria-expanded', 'false');
    };

    // Close all submenus
    const closeAllSubmenus = () => {
      if (document.querySelector('.dropdown-menu__expand-button--expanded')) {
        for (let i = 0; i < dropdownButtonsLength; i++) {
          closeSubmenu(dropdownButtons[i]);
        }
      }
    };

    // Toggle submenu open and closed on button click
    const toggleSubmenu = (buttonClick) => {
      const button = buttonClick.target;

      const submenuWasOpen = button.classList.contains(
        'dropdown-menu__expand-button--expanded'
      );

      button.classList.add('dropdown-menu__expand-button--has-been-opened');

      if (topLevelButtons.indexOf(button) !== -1) {
        closeAllSubmenus();
      }

      if (!submenuWasOpen) {
        openSubmenu(button);
      }
    };

    // Close parent menu on back button click
    const closeParentMenu = (buttonClick) => {
      const backButton = buttonClick.target;

      closeSubmenu(
        backButton
          .closest('ul')
          .closest('li')
          .querySelector('.dropdown-menu__expand-button')
      );
    };

    // Add a back button to each submenu
    for (let i = 0; i < secondLevelFirstItemsLength; i++) {
      const firstItem = secondLevelFirstItems[i];
      const parentUL = firstItem.parentNode;

      // Check if a back button has already been added to the parent UL
      if (!addedBackButtons.has(parentUL)) {
        // Check if there is an existing back button in the parent UL
        const existingBackButton = parentUL.querySelector(
          '.dropdown-menu__back-button'
        );

        // Remove any existing back button
        if (existingBackButton) {
          parentUL.removeChild(existingBackButton.parentNode);
        }

        // Create a new back button element and append it to the UL
        const backButtonItem = document.createElement('li');
        const backButton = backButtonTemplate.cloneNode(true);

        backButtonItem.classList.add('dropdown-menu__subitem');
        backButtonItem.appendChild(backButton);

        backButton.classList.remove('dropdown-menu__back-button-template');
        backButton.classList.add('dropdown-menu__back-button');

        parentUL.insertBefore(backButtonItem, firstItem);

        // Add the parent UL to the addedBackButtons set to avoid adding
        // another back button to the same UL
        addedBackButtons.add(parentUL);
      }
    }

    // Add click event listeners to the back buttons to close the parent submenu
    const backButtons = context.querySelectorAll('.dropdown-menu__back-button');
    const backButtonsLength = backButtons.length;

    // Add click event listeners to the dropdown buttons to toggle the submenu
    for (let i = 0; i < backButtonsLength; i++) {
      backButtons[i].onclick = closeParentMenu;
    }

    // Add a resize event listener to the window to close all submenus when the window is resized
    for (let i = 0; i < dropdownButtonsLength; i++) {
      dropdownButtons[i].onclick = toggleSubmenu;
      dropdownButtons[i].classList.add('js-dropdown-menu__expand-button');
    }

    window.addEventListener('resize', closeAllSubmenus);

    // Add a click event listener to the document to close all submenus when
    // the user clicks outside of them
    document.documentElement.onclick = (event) => {
      for (let i = 0; i < dropdownMenusLength; i++) {
        if (dropdownMenus[i].contains(event.target)) {
          return;
        }
      }

      closeAllSubmenus();
    };
  };

  // Attach the dropdownMenu function to the Drupal behaviors object
  Drupal.behaviors.dropdownMenu = {
    attach: dropdownMenu
  };
})(document, Drupal);
